import { OfficeThemeMode, } from '@office-start/theming-types';
import { HarmonyThemeMode as HarmonyThemeModeVisuals } from '@office-start/visual-types';
export var resolveThemeMode = function (_a) {
    var _b;
    var entitlements = _a.entitlements, harmonyThemeModeVisuals = _a.harmonyThemeModeVisuals, shellTheme = _a.shellTheme, userShellAppTheme = _a.userShellAppTheme;
    if (entitlements === null || entitlements === void 0 ? void 0 : entitlements.isPwaInUwp) {
        // $TODO: If in the desktop application and the user has a dark theme set in Windows, use the dark theme
        // const colorSettings = new Windows.UI.ViewManagement.UISettings();
        // const colorValue = colorSettings.getColorValue(Windows.UI.ViewManagement.UIColorType.background);
        // if (colorValue.a === 255 && colorValue.b === 0 && colorValue.g === 0 && colorValue.r === 0) {
        //     return this.getDefaultDarkTheme();
        // }
        return OfficeThemeMode.default;
    }
    else {
        // Default to visual mode if it exists for consumers (shellTheme may be undefined or incorrect on initial renders before overrides are applied)
        // After initial render for consumer, and when overrides are applied, the shellTheme will be correct.
        // (ShellTheme + visual theme mode are used for comparison in useUpdateVisualThemeMode to determine whether or not to apply overrides on theme changes.
        // Code below is for initial bootstrap)
        //
        // Default to shell theme mode for enterprise
        return (entitlements === null || entitlements === void 0 ? void 0 : entitlements.isConsumerUser) &&
            harmonyThemeModeVisuals === HarmonyThemeModeVisuals.Dark
            ? OfficeThemeMode.dark
            : (_b = shellTheme === null || shellTheme === void 0 ? void 0 : shellTheme.mode) !== null && _b !== void 0 ? _b : ((userShellAppTheme === null || userShellAppTheme === void 0 ? void 0 : userShellAppTheme.darkMode)
                ? OfficeThemeMode.dark
                : OfficeThemeMode.default);
    }
};
//# sourceMappingURL=resolveThemeMode.js.map